"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryTaxonomyLoader = void 0;
var countryTaxonomyLoader_1 = require("./countryTaxonomyLoader");
Object.defineProperty(exports, "countryTaxonomyLoader", { enumerable: true, get: function () { return countryTaxonomyLoader_1.countryTaxonomyLoader; } });
